import { PageDealType, DealList, CategoryType, PopularBrand } from '@types';
import {
  comboFieldTypes,
  pageDealTypes
  // bannedBrands,
  // notPostingDealLists
} from '../../utils';

export const getPageDealOptionsTypesToRender = (
  editMode: boolean,
  pageDeals: PageDealType[]
) =>
  pageDealTypes.filter((sect) => {
    if (editMode) {
      return true;
    }

    if (
      !comboFieldTypes.includes(sect.value) &&
      (pageDeals || []).length > 0 &&
      (pageDeals || []).some((pageDeal) => pageDeal.type === sect.value)
    ) {
      return null;
    }

    return true;
  });

export const getDealListOptionsToRender = (
  editMode: boolean,
  lists: DealList[],
  dealListId: number,
  pageDeals: PageDealType[]
) => {
  return (
    (lists || [])
      .slice() // Create a copy of the array to avoid mutating the original
      .sort((a, b) => b.numLiveDeals - a.numLiveDeals) // Sort in descending order by numLiveDeals
      // if editMode is true and the current value of "brand" isn't in there then add it
      .concat(
        editMode && !(lists || []).some((list) => list.id === dealListId)
          ? [
              {
                id: dealListId,
                name: `Not live dealListId ${dealListId}`,
                numLiveDeals: 0,
                sectionId: 0,
                isWeekly: false,
                description: '',
                isActive: true,
                activeTimeFrame: 'ALL'
              }
            ]
          : []
      )
      .filter((section) => {
        // if any of the current deal lists have the section id, don't show it
        if (
          !editMode &&
          (pageDeals || []).some(
            (pageDeal) => pageDeal.dealListId === section.id
          )
          // (notPostingDealLists || []).some(
          //   (notPostingDealList) =>
          //     notPostingDealList?.toLowerCase() === section.name.toLowerCase()
          // ))
        ) {
          return false;
        }

        return true;
      })
      .map((section) => {
        return {
          name: `${section.name} (${section.numLiveDeals})`,
          value: section.id
        };
      })
  );
};

export const getCategoryOptionsToRender = (
  editMode: boolean,
  categories: CategoryType[],
  pageDeals: PageDealType[],
  type: string
) => {
  return (categories || [])
    .filter((cat) => {
      return cat.numLiveDeals > 6;
    })
    .filter((categoryLive) => {
      // if any of the current deal lists have the section id, don't show it
      if (
        !editMode &&
        (pageDeals || []).some(
          (pageDeal) =>
            pageDeal.category === categoryLive.category &&
            pageDeal.type === type
        )
      ) {
        return false;
      }

      return true;
    })
    .map((categoryLive) => {
      return {
        name: `${categoryLive.category} (${categoryLive.numLiveDeals})`,
        value: categoryLive.category
      };
    });
};

export const getPopularBrandsToRender = (
  editMode: boolean,
  popularBrands: PopularBrand[],
  pageDeals: PageDealType[],
  brand: string
) => {
  return (
    (popularBrands || [])
      .filter(() => {
        if (editMode) {
          return true;
        }
        return true;
      })
      // if editMode is true and the current value of "brand" isn't in there then add it
      .concat(
        editMode && !(popularBrands || []).some((pop) => pop.brand === brand)
          ? [{ brand, count: 0 }]
          : []
      )
      .filter((popularBrand) => {
        // if any of the current deal lists have the section id, don't show it
        if (
          !editMode &&
          (pageDeals || []).some(
            (pageDeal) =>
              pageDeal.brand === popularBrand.brand && pageDeal.type === 'BRAND'
          )
        ) {
          return false;
        }
        return true;
      })
      .map((popularBrand) => {
        return {
          name: `${popularBrand.brand} (${popularBrand.count})`,
          value: popularBrand.brand
        };
      })
  );
};
